<template>
    <v-dialog
            :value="shownRelay"
            :persistent="true"
            :width="dlgWidth"
            :fullscreen="fullScreen"
    >
        <v-card :class="{
          'fill-height': fullScreen,
          'of-y': fullScreen,
          'flex-column': fullScreen,
          'd-flex': fullScreen,
        }">
            <v-progress-linear
                    v-if="showLoading"
                    color="primary"
                    :indeterminate="loadingProgress === 0"
                    :value="loadingProgress"
            ></v-progress-linear>

            <template v-if="hasHeaderSlot">
                <div :class="{'flex-grow-0': fullScreen}">
                  <slot name="header"></slot>
                </div>
            </template>
            <v-card-title v-else class="dlg-title-bar" :class="{'flex-grow-0': fullScreen}">
                {{title || 'title'}}
            </v-card-title>
            <v-card-text class="pt-3" :class="{
              'pa-0': !defaultPadding,
              'ma-0': !defaultPadding,
              'flex-grow-1': fullScreen,
              'of-y': fullScreen,
            }" >
                <slot></slot>
                <v-text-field
                        v-if="!!$props['showTf']"
                        v-bind="$attrs"
                        v-model="modelStringRelay"
                        ref="tf"
                        @keydown.enter="$emit('enter', $event)"
                >
                </v-text-field>
            </v-card-text>
            <v-divider v-if="hasActionsSlot"/>
            <v-card-actions v-if="hasActionsSlot" :class="{'flex-grow-0': fullScreen}">
                <v-spacer v-if="addActionSpacer"/>
                <slot name="actions"></slot>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        dlgWidth: {
            default: 400,
            type: Number
        },
        showLoading: {
            type: Boolean,
            default: false
        },
        loadingProgress: {
            type: Number,
            default: 0
        },
        defaultPadding: {
            type: Boolean,
            default: true
        },
        title: String,
        showTf: {
            type: Boolean,
            default: false
        },
        modelString: String,
        showDlg: {
            default: false,
            type: Boolean
        },
        addActionSpacer: {
            type: Boolean,
            default: true
        },
      fullScreen: {
          type: Boolean,
        default: false
      }
    },
    created() {
        // console.log(this.)
    },
    data() {
        return {
            refVal: null
        }
    },
    watch: {
        showDlg: {
            immediate: true,
            handler(val) {
                if (val && !!this.$props['showTf'])
                    setTimeout(() => {
                        this.$refs.tf.focus();
                    }, 500)

            }
        }
    },
    computed: {
        hasHeaderSlot() {return !!this.$slots.header},
        hasActionsSlot() {return !!this.$slots.actions},
        modelStringRelay: {
            get() {
                return this.modelString
            },
            set(val) {this.$emit('update:modelString', val)}
        },
        shownRelay: {
            get() {
                return this.showDlg
            },
            set(val) {this.$emit('update:showDlg', val)}
        }
    },
}
</script>

<style scoped>

</style>